import { render } from "./TotalPayable.vue?vue&type=template&id=3c9612ba"
import script from "./TotalPayable.vue?vue&type=script&lang=ts"
export * from "./TotalPayable.vue?vue&type=script&lang=ts"
script.render = render

export default script